import { useState } from "react";
import { FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";
import { download } from "@/admin/hr/common";
import { Title } from "@/ops/ui";
import { FilterBar, initRange } from "@/ops/filters";

const KINDS = [["devriye", "Günlük / aylık devriye raporu", "En fazla 31 gün"], ["checkpoints", "Proje bazlı kontrol noktası raporu", "Konum kaydı, okutma ve red sayıları"],
  ["devriye", "Personel bazlı devriye raporu", "Personel filtresini seçin"], ["gps", "GPS doğrulama ve reddedilen işlemler", "En fazla 93 gün"],
  ["missing", "Eksik ve geciken devriyeler", "En fazla 31 gün"], ["photo", "Fotoğraflı görev raporu", "En fazla 31 gün"],
  ["attendance", "Vardiya ve giriş-çıkış raporu", "En fazla 62 gün"], ["timesheet", "Aylık puantaj", "Başlangıç tarihinin ayı kullanılır"],
  ["documents", "Özlük belgeleri geçerlilik raporu", "Tüm belgeler ve kimlik kartları"], ["incidents", "Olay bildirimleri", "En fazla 366 gün"]];

export default function Reports() {
  const [f, setF] = useState(initRange());
  const get = (kind, fmt) => download(`/ops/admin/reports/${kind}.${fmt}`, `${kind}-${f.date_from}.${fmt}`, { params: f }).catch(() => toast.error("Rapor oluşturulamadı"));
  return (
    <div>
      <Title title="Raporlar ve Dışa Aktarma" desc="Filtreler tüm raporlara uygulanır. Raporlar kişisel veri içerir; yalnızca yöneticiler indirebilir ve her indirme kayda geçer." />
      <FilterBar f={f} setF={setF} />
      <div className="grid gap-3 md:grid-cols-2">
        {KINDS.map(([k, l, h], i) => (
          <div key={l} className="flex items-center justify-between gap-3 rounded-lg border border-zinc-200 bg-white p-4" data-testid={`report-card-${i}`}>
            <div><p className="font-semibold">{l}</p><p className="text-xs text-zinc-500">{h}</p></div>
            <div className="flex shrink-0 gap-2">
              <button onClick={() => get(k, "xlsx")} className="btn-outline !px-3 !py-2" data-testid={`report-${i}-xlsx`}><FileSpreadsheet className="h-4 w-4" /> Excel</button>
              <button onClick={() => get(k, "pdf")} className="btn-outline !px-3 !py-2" data-testid={`report-${i}-pdf`}><FileText className="h-4 w-4" /> PDF</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
